module.exports = __webpack_public_path__ + "static/media/how-we-can-adapt-plants-to-save-our-planet.5aae94e9.jpg";